import { CapoPlugin } from "/home/runner/work/ticketco-portal/ticketco-portal/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];